//client/src/hooks/useComunicacaoConfigAgendamento.js
import { useQuery } from '@tanstack/react-query';
import apiClient from '../services/api';
import useAlert from './useAlert';

export const useComunicacaoConfigAgendamento = (evento, tipo = 'Automatica') => {
    const { setAlert } = useAlert();

    return useQuery({
        queryKey: ['comunicacaoConfig', evento, tipo],
        queryFn: async () => {
            try {
                const { data } = await apiClient.get('/comunicacao-config', {
                    params: { evento, tipo }
                });
                return data.data;
            } catch (error) {
                setAlert(error.response?.data?.error || 'Erro ao carregar configurações', 'danger');
                throw error;
            }
        },
        enabled: !!evento,
    });
};